import { Checkbox, Typography } from 'antd';
import Container from '../UI/Container/Container';
import classes from './Form.module.scss';
import Input from '../UI/Input/Input';
import { useTranslation } from 'react-i18next';
import { Form } from 'antd';
import Button from '../UI/Button/Button';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import parse from 'html-react-parser';

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: false,
  positionClass: 'toast-top-center',
  preventDuplicates: false,
  onclick: null,
  showDuration: '300',
  hideDuration: '1000',
  timeOut: '5000',
  extendedTimeOut: '1000',
  showEasing: 'swing',
  hideEasing: 'linear',
  showMethod: 'fadeIn',
  hideMethod: 'fadeOut'
};

const MainForm = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const onSubmit = (data) => {
    fetch('https://formkeep.com/f/31d8f4f21cb5', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: data.email
      })
    })
      .then((response) => {
        toastr.success(t('form.success'), t('form.successTitle'));
        form.resetFields();
      })
      .catch((e) => {
        toastr.error(t('form.error'), t('form.errorTitle'));
      });
  };

  return (
    <div className={classes.bg}>
      <Container>
        <div className={classes.body}>
          <div className={classes.form}>
            <div className={`${classes.text} ${classes.mob}`}>
              <h2 className={classes.text__title}>{t('form.title')}</h2>
              <Typography className={classes.text__description}>
                {t('form.description')}
              </Typography>
            </div>
            <Form
              form={form}
              layout='vertical'
              onFinish={onSubmit}
              style={{ width: '100%' }}
            >
              <Form.Item
                name='email'
                rules={[{ required: true, message: t('schema.required') }]}
                style={{margin: 0}}
              >
                <Input
                  className={classes.input}
                  size='large'
                  placeholder={t('input.email')}
                />
              </Form.Item>
              <Form.Item
                name='agreement'
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject(new Error(t('schema.required')))
                  }
                ]}
                valuePropName='checked'
              >
                <Checkbox
                  className={classes.checkbox}
                  style={{ marginTop: 21, alignItems: 'center' }}
                  // onChange={onToggleCheckbox}
                >
                  <Typography style={{ color: 'white', fontWeight: 400 }}>
                    {parse(t('form.agreement'))}
                  </Typography>
                </Checkbox>
              </Form.Item>
              <Button
                wide
                mode='contained'
                style={{ marginTop: 20 }}
                onClick={() => form.submit()}
              >
                {t('form.button')}
              </Button>
            </Form>
          </div>
          <div>
            <div className={`${classes.text} ${classes.pc}`}>
              <h2 className={classes.text__title}>{t('form.title')}</h2>
              <Typography className={classes.text__description}>
                {t('form.description')}
              </Typography>
            </div>
            <div className={classes.networks}>
              <a
                href='mailto:info@tigsipay.com'
                target='_blank'
                rel='noreferrer'
                className={classes.networks__item}
              >
                info@tigsipay.com
              </a>
              <div className={classes.networks__inner}>
                <a
                  href='https://www.instagram.com/tigsi_pay/'
                  target='_blank'
                  rel='noreferrer'
                  className={classes.networks__item}
                >
                  <img src='/icons/instagram.svg' alt='instagram' />
                </a>
                <a
                  href='https://www.facebook.com/TigsiPay'
                  target='_blank'
                  rel='noreferrer'
                  className={classes.networks__item}
                >
                  <img src='/icons/facebook.svg' alt='facebook' />
                </a>
                <a
                  href='https://www.linkedin.com/company/tigsipay/'
                  target='_blank'
                  rel='noreferrer'
                  className={classes.networks__item}
                >
                  <img src='/icons/linkedIn.svg' alt='linked in' />
                </a>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default MainForm;
